/** Removes excess whitespace, as per {@link @runn/core#helpers.string.squish}.  */
export function squish(str: string): string {
  const regex =
    /[\s\u0085\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+/gu

  return str.replace(regex, " ").trim()
}
